import { React, useEffect, useState } from 'react'
import "./Brands.css"
import { Container } from 'react-bootstrap'
import { LinkBtn, Title } from '../../../../Components'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import axios from "axios";
import { toast } from 'react-toastify';
import { Skeleton } from '@mui/material';


const Brands = ({ url, section, setEmptyBrandList, homeLoading }) => {

    const [loading, setLoading] = useState(true);
    const [brandsData, setData] = useState({});
    const resultsPerPage = 10;

    useEffect(() => {
        if (homeLoading == false && section && loading)
            setTimeout(() => {
                fetchData();
            }, 1500);
    }, [homeLoading]);

    const fetchData = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const start = (pageNumber - 1) * resultsPerPage;
            let apiUrl = `${url}/api/method/erpnext.setup.doctype.brand.brand.brands?start=${start}&limit=${resultsPerPage}`;
            const response = await axios.get(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.data.status_code !== 200) {
                toast.error("Failed to fetch data. Please try again..");
            }
            const result = response.data.result;
            setData(result.objects);
            if (result.objects.length === 0) {
                setEmptyBrandList(true)
            }
            setLoading(false);
        } catch (error) {
            toast.error("Failed to fetch data. Please try again..");
            setLoading(false);
        }
    };

    return (
        <div className='brands'>
            <Container>
                <Title
                    overlay={"Brands"}
                    title={"Devices By Brands"}
                />
            </Container>
            {loading ? (
                <div className='brands-slider'>
                    <Splide
                        options={{
                            type: "loop",
                            arrows: true,
                            pagination: false,
                            gap: "50px",
                            perPage: 5,
                            autoWidth: true,
                            perMove: 1,
                            speed: 500, // Set auto scroll speed
                            autoplay: true, // Enable auto scroll
                            interval: 2000, // Auto scroll interval in ms
                            pauseOnHover: true, // Pause on hover
                            breakpoints: {
                                768: {
                                    perPage: 4,
                                    gap: "20px" // Reduce gap for smaller screens
                                },
                                576: {
                                    perPage: 3,
                                    gap: "10px" // Further reduce gap for very small screens
                                }
                            }
                        }}
                    >
                        {Array.from({ length: 7 }).map((_, index) => (
                            <SplideSlide key={index}>
                                <div>
                                    <Skeleton className="brands-slider-image-skelton" animation="wave" variant="rectangular" />
                                </div>
                            </SplideSlide>
                        ))}
                    </Splide>
                </div>
            ) : (
                <div className='brands-slider'>
                    <Splide
                        options={{
                            type: "loop",
                            arrows: true,
                            pagination: false,
                            gap: "50px",
                            perPage: 5,
                            autoWidth: true,
                            perMove: 1,
                            speed: 500, // Auto scroll speed adjustment
                            autoplay: true, // Enable auto scroll
                            interval: 2000, // Auto scroll interval
                            pauseOnHover: true, // Pause on hover
                            focus: "center",
                            breakpoints: {
                                768: {
                                    perPage: 4,
                                    gap: "20px" // Reduce gap for smaller screens
                                },
                                576: {
                                    perPage: 3,
                                    gap: "10px" // Further reduce gap for very small screens
                                }
                            }
                        }}
                    >
                        {brandsData && brandsData.map((item, index) => (
                            <SplideSlide key={index}>
                                <div className='brands-slider-image'>
                                    <img
                                        className='brands-slider-img'
                                        src={url + "/" + item.image}
                                        alt={`Brand-${index}`}
                                    />
                                </div>
                            </SplideSlide>
                        ))}
                    </Splide>
                </div>
            )}
            <LinkBtn
                link={"/brands"}
                titleLink={"See All Brands"}
            />
        </div>
    )
}

export default Brands;
